module.exports = __webpack_public_path__ + "img/down_arrow.5b95b51e.svg";